import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="screen-design-form"
export default class extends Controller {
  static targets = [
    "pageSelect", "pageInfo", "pageName", "pagePath", "pageDescription", "pageType",
    "requirements", "submitBtn"
  ]

  connect() {
    console.log("Screen Design Form controller connected")
  }

  // Update page info when sitemap page is selected
  updatePageInfo(event) {
    const selectedPageId = event.target.value
    
    if (!selectedPageId) {
      this.hidePageInfo()
      return
    }

    // Get page data from the global sitemapPages variable set in the view
    if (typeof sitemapPages !== 'undefined') {
      const selectedPage = sitemapPages.find(page => page.id == selectedPageId)
      
      if (selectedPage) {
        this.showPageInfo(selectedPage)
      } else {
        this.hidePageInfo()
      }
    }
  }

  showPageInfo(page) {
    console.log("Showing page info for:", page)
    
    if (this.hasPageInfoTarget) {
      // Update page information
      this.pageNameTarget.textContent = page.name
      this.pagePathTarget.textContent = page.path
      this.pageDescriptionTarget.textContent = page.description || 'No description provided'
      this.pageTypeTarget.textContent = (page.page_type || 'page').replace('_', ' ')
      
      // Show the info panel
      this.pageInfoTarget.classList.remove('hidden')
    }
  }

  hidePageInfo() {
    if (this.hasPageInfoTarget) {
      this.pageInfoTarget.classList.add('hidden')
    }
  }

  // Handle form submission
  submit(event) {
    console.log("Form submit intercepted by Stimulus controller")
    
    // Validate required fields
    const pageSelected = this.pageSelectTarget.value
    const requirements = this.requirementsTarget.value.trim()
    
    if (!pageSelected) {
      event.preventDefault()
      alert("Please select a sitemap page.")
      this.pageSelectTarget.focus()
      return false
    }
    
    // Requirements are now optional - will be auto-generated from page attributes if not provided
    // No validation needed for requirements field
    
    // Show loading state on submit button
    if (this.hasSubmitBtnTarget) {
      this.submitBtnTarget.disabled = true
      this.submitBtnTarget.innerHTML = '<span class="loading loading-spinner loading-sm"></span> Generating...'
    }
    
    console.log("Submitting screen design form with:", {
      pageId: pageSelected,
      requirements: requirements || "Auto-generating from page attributes"
    })
    
    console.log("Validation passed, allowing form submission to proceed")
    // Allow form to submit normally by not preventing default
  }
}